import styled from "styled-components";
import { Link } from "react-router-dom";
import { border, breakpoint, color, font } from "../../../theme";
import userIcon from "../../../assets/svg/ic-user.svg";
import logoutIcon from "../../../assets/svg/ic-logout.svg";
import calendarIcon from "../../../assets/svg/ic-calendar.svg";

const narrowHeader = "430px";

export const NotificationContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const NotificationIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${color.white};
  color: ${color.primary};
  width: 40px;
  height: 40px;
  margin-right: 10px;
`;

// new design
// layout
export const Inner = styled.div<{ isLogin: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  padding-bottom: 10rem;
  @media (max-width: ${narrowHeader}) {
    align-items: flex-start;
  }
  @media (min-width: ${breakpoint.tablet}) {
    margin-bottom: ${(p) => (p.isLogin ? "0" : "3rem")};
    padding-bottom: 0;
  }
  @media (min-width: ${breakpoint.desktop}) {
    margin-bottom: ${(p) => (p.isLogin ? "0" : "6rem")};
  }
`;

// logo
export const LogoContainer = styled(Link)<{ $isLogin: boolean }>`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
  @media (min-width: ${breakpoint.desktop}) {
    width: ${(p) => (p.$isLogin ? "auto" : "7.6%")};
  }
`;

export const LogoImage = styled.img<{ isLogin: boolean }>`
  user-select: none;
  flex-shrink: 0;
  max-width: none;
  margin-right: 16px;
  width: 44px;
  min-width: 44px;
  height: 44px;
  @media (min-width: ${breakpoint.desktop}) {
    margin-left: 2px;
  }
`;

export const LogoutButton = styled(Link)<{ $isLogin: boolean }>`
  display: flex;
  align-items: center;
  text-decoration: none;
  @media (min-width: ${breakpoint.desktop}) {
    width: ${(p) => (p.$isLogin ? "auto" : "7.6%")};
  }
`;

export const LogoutIcon = styled.img`
  user-select: none;
  width: 6rem;
  @media (min-width: ${breakpoint.desktop}) {
    width: 4rem;
    margin-right: 1rem;
  }
`;

export const LogoTitle = styled.span`
  font-family: ${font.family.primary};
  font-weight: 500;
  text-transform: uppercase;
  color: ${color.link};
  font-size: 2.7rem;
  width: 4em;
  line-height: 1em;
  @media (min-width: ${breakpoint.tablet}) {
    font-size: 2.8rem;
    display: inline;
    width: auto;
  }
`;

// page title
export const PageTitle = styled.span`
  font-size: 3.3rem;
  color: ${color.grey};
  position: absolute;
  left: 0;
  bottom: 2rem;
  @media (min-width: ${breakpoint.tablet}) {
    display: block;
    position: initial;
    flex-shrink: 0;
    margin-right: 24px;
    font-size: 3rem;
  }
`;

// search
export const HeaderSearch = styled.div`
  position: relative;
  margin: 0 0 0 auto;
  cursor: pointer;
  border-radius: ${border.radius};
  width: 7rem;
  height: 7rem;
  background: #fff;
  @media (min-width: ${breakpoint.tablet}) {
    width: 48.5%;
    background: transparent;
    height: auto;
  }
  @media (min-width: ${breakpoint.desktop}) {
    margin: 0 auto 0 10.8rem;
  }
`;

export const HeaderSearchInput = styled.input`
  width: 100%;
  background: #fff;
  border: none;
  outline: none;
  line-height: 5.8rem;
  box-shadow: -5px 15px 30px -5px rgba(73, 88, 110, 0.2);
  border-radius: ${border.radius};
  padding-left: 2rem;
  font-size: 1.6rem;
  display: none;
  @media (min-width: ${breakpoint.tablet}) {
    display: block;
  }
`;

export const HeaderSearchIcon = styled.img`
  width: 3rem;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media (min-width: ${breakpoint.tablet}) {
    width: 2rem;
    right: 2rem;
    top: 50%;
    left: auto;
    transform: translate(0, -50%);
    opacity: 0.8;
  }
`;

export const HeaderIcons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 0;
  gap: 16px;
  margin-left: auto;
  @media (max-width: ${narrowHeader}) {
    flex-wrap: wrap;
    row-gap: 8px;
  }
`;

// user
export const HeaderUser = styled.div`
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: url(${userIcon}) center center no-repeat, #fff;
  background-size: 2rem auto;
  box-shadow: -5px 15px 30px -5px rgba(255, 255, 255, 0.3);
  border-radius: ${border.radius};
  cursor: pointer;
  display: none;
  @media (min-width: ${breakpoint.desktop}) {
    display: block;
  }
`;

// logout
export const HeaderLogout = styled.div`
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  background: url(${logoutIcon}) center center no-repeat, #ff6c01;
  background-size: 20px auto;
  box-shadow: -5px 15px 30px -5px rgba(255, 108, 1, 0.3);
  border-radius: 16px;
  cursor: pointer;
  display: block;
  @media (min-width: ${breakpoint.desktop}) {
    display: none;
  }
`;

// calendar
export const HeaderCalendar = styled.div`
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  background: url(${calendarIcon}) center center no-repeat, #fff;
  background-size: 20px auto;
  border-radius: 16px;
  cursor: pointer;
`;

export const SearchContainer = styled.div<{ $limited?: boolean }>`
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 16px;
  width: 100%;
  ${(p) =>
    p.$limited &&
    `
    width: auto;
    flex: 0 1 662px;
    max-width: 662px;
  `}
`;

export const HeaderSearchField = styled.div`
  flex: 1 1 600px;
  width: 600px;
  max-width: 100%;
  min-width: 0;
  input {
    height: 48px;
    font-size: 16px;
    line-height: 24px;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const HeaderToolSlot = styled.div<{ $order: number }>`
  display: contents;
  @media (max-width: ${narrowHeader}) {
    display: flex;
    order: ${(p) => p.$order};
    flex: 1 0 100%;
    justify-content: flex-end;
    min-width: 0;
    max-width: 100%;
  }
`;

export const BalanceContainer = styled.div`
  background: #ffffff;
  height: 48px;
  border-radius: 16px;
  display: flex;
  flex-shrink: 0;
  max-width: 100%;
  margin-left: auto;
  .main-container {
    min-width: 120px;
    overflow: hidden;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 6px;
    .title {
      font-family: "Fira Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #999999;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .balance {
      font-family: "DNC";
      font-style: normal;
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      text-transform: uppercase;
      color: #687591;
      white-space: nowrap;
      cursor: pointer;
    }
  }
  .button-outcome {
    background: #ffffff;
    flex-shrink: 0;
    height: 48px;
    width: 48px;
    cursor: pointer;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.blocked {
      cursor: default;
      opacity: 0.5;
      .icon-outcome * {
        stroke: #333 !important;
      }
      &:hover {
        background: #ffffff !important;
        .icon-outcome * {
          stroke: #333 !important;
        }
      }
    }
    &:hover {
      background: #00a0e3;
      .icon-outcome * {
        stroke: #ffffff !important;
      }
    }
  }
`;

export const LoteryContainer = styled.div`
  background: #ffffff;
  height: 48px;
  border-radius: 16px;
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
  max-width: 100%;
  @media (max-width: ${narrowHeader}) {
    margin-right: 0;
  }
  .main-container {
    min-width: 120px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 6px;
    .title {
      font-family: "Fira Sans";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #999999;
      white-space: nowrap;
    }
    .description {
      font-family: "Fira Sans";
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 14px;
      color: #687591;
    }
  }
  .button-win {
    background: #44cc7a;
    height: 48px;
    width: 48px;
    cursor: pointer;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
